import { http, getApiUrl } from './request.js'

// 订单列表
const orderlist = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order/list'), payload);
}

//订单指派司机
const assignDriver = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order/assignment'), payload)
}


// 上传箱封照信息
const uploadContainerSealNo = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order/upload-container-sealNo'), payload);
}

// 上传箱封照
const uploadSeals = (payload) => {
    return http.post(getApiUrl('/filemanager/file/upload'), payload, {
        headers: {
            "Content-Type": "multipart/form-data;"
        }
    });
}
// 查询文件
const queryFile = (payload) => {
    return http.post(getApiUrl('/filemanager/file/biz/query'), payload);
}

// 装箱单
const packingList = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order/container-load-plan'), payload);
}

// 装箱单HTML(dms生成,后端代理)
const packingListHtml = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order/container-load-plan-html'), payload);
}

//订单司机信息
const orderDriver = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order/order-driver'), payload)
}

// 查看箱封照
const reqcontainerSeal = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/attachment-info/container-attachment-info'), payload)
}

// 查询运输节点状态
const orderTrackStatus = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order-tracking-info/order-track'), payload)
}

// 运输节点详细信息
const trackFeedbackDetail = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order-tracking-info/track-feedback'), payload)
}

// 根据类型查看箱子附件
const containerAttachments = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/attachment-info/container-attachments-by-type'), payload)
}

// 下载附件
const downloadAttachment = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/attachment-info/download-attachment'), payload, { responseType: 'blob' })
}

// 查看报关附件
const queryDeclarationAttachment = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/declaration/query-declaration-attachment'), payload)
}

// 根据提单号获取报关信息
const getDeclarationByBlNo = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/declaration/getByBlNo'), payload)
}

// 上传报关附件
const uploadDeclarationAttachment = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/declaration/upload-declaration-attachment'), payload)
}

// 下载报关附件
const downloadCustomsDeclaration = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/declaration/download-customs-declaration'), payload, { responseType: 'blob' })
}

// 上传过磅信息
const feedbackContainerWeighing = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order/feedback-container-weighing'), payload)
}

// 查看过磅信息状态
const containerWeighingInfo = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/order-tracking-info/container-weighing-info'), payload)
}

export {
  orderlist,
  assignDriver,
  uploadContainerSealNo,
  packingList,
  packingListHtml,
  orderDriver,
  uploadSeals,
  reqcontainerSeal,
  orderTrackStatus,
  trackFeedbackDetail,
  containerAttachments,
  downloadAttachment,
  queryFile,
  getDeclarationByBlNo,
  uploadDeclarationAttachment,
  queryDeclarationAttachment,
  downloadCustomsDeclaration,
  feedbackContainerWeighing,
  containerWeighingInfo,
};
